var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:visible"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 6C5.188 6 1 12 1 12C1 12 5.188 18 12 18C18.812 18 23 12 23 12C23 12 18.812 6 12 6ZM12 16C8.057 16 5.074 13.516 3.621 12C4.661 10.915 6.483 9.343 8.875 8.531C8.3117 9.23091 8.00314 10.1016 8 11C8 12.0609 8.42143 13.0783 9.17157 13.8284C9.92172 14.5786 10.9391 15 12 15C13.0609 15 14.0783 14.5786 14.8284 13.8284C15.5786 13.0783 16 12.0609 16 11C15.9969 10.1016 15.6883 9.23091 15.125 8.531C17.518 9.343 19.341 10.916 20.379 12C18.924 13.518 15.942 16 12 16Z",
    fill: "#495568",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/Open_eye_icon.f6a988b76d57264a6ea4c80dc2060d4d.svg";
export { ForwardRef as ReactComponent };